import * as api from "@/api/pace";
import { AnalysisPaceDTO } from "@/api/pace/types";

export async function getByUuid(uuid: string, crop_type: string): Promise<AnalysisPaceDTO> {
  return (await api.getByUuid(uuid, crop_type)).data;
}
